import React from 'react';

import { ConstrainedTextFieldComponent } from '../ConstrainedTextField';

import { FieldContext, FieldLocator } from '../../types';
import { isConstrainedTextField } from '../../utils';

type ComponentProps = React.ComponentProps<typeof ConstrainedTextFieldComponent>;

export const MemberAccountNumberComponent = (
  props: ComponentProps,
) => {
  const handleOnChange = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/\s/g, '');
  };
  const fieldProp: Record<string, any> = [];
  fieldProp.onChange = handleOnChange;

  return (
    <ConstrainedTextFieldComponent {...props} fieldProps={fieldProp} />
  );
};

export const memberAccountNumberFieldId = 'MemberAccountNumber';

export const isMemberAccountNumber = ({ field }: FieldContext) => (
  isConstrainedTextField(field) && field.id === memberAccountNumberFieldId
);

export const MemberAccountNumberLocator: FieldLocator = (context) => (
  isMemberAccountNumber(context)
    ? MemberAccountNumberComponent
    : undefined
);
